import Axios from 'axios';
import { protectedResources } from '../authConfig';

const URL =
  protectedResources.apiHRMobile.baseApi +
  '/api/v1/BackOffice/GetAdvanceSalaryRequestSummary';
let tokenKey;

export async function setRequestDashboard(year, month) {
  if (sessionStorage.getItem('AccessToken') !== null) {
    tokenKey = JSON.parse(sessionStorage.getItem('AccessToken')).value;
  }

  const config = {
    headers: { Authorization: `Bearer ${tokenKey}` },
  };

  const bodyParameters = {
    year: year,
    month: month,
  };

  try {
    const response = await Axios.post(URL, bodyParameters, config);
    return await response.data;
  } catch (error) {
    console.error(error);
  }
}
